import React from 'react';
export var AppsRenderer = function AppsRenderer(_ref) {
  var ForgeAppRenderer = _ref.ForgeAppRenderer,
    apps = _ref.apps;
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};